import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-thankyou-purchase-dialog",
    templateUrl: "./thankyou-purchase-dialog.component.html",
    styleUrls: ["./thankyou-purchase-dialog.component.scss"],
    standalone: false
})
export class ThankyouPurchaseDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
	) {}
}
